import { userResourcesLanguageFrench } from '../userResources';

import type { RolesTranslationMessages } from './rolesTranslationMessages';

export const rolesLanguageFrench: RolesTranslationMessages = {
  roles: {
    ...userResourcesLanguageFrench.groups,
    name: 'Rôles',
    description:
      'En sélectionnant le rôle, tous les droits seront générés automatiquement. Vous pourrez les modifier par la suite.',
    fields: {
      ...userResourcesLanguageFrench.groups.fields,
      name: 'Nom du rôle',
    },
    operations: {
      ...userResourcesLanguageFrench.groups.operations,
      create: 'Créer un rôle',
      delete: 'Supprimer le rôle',
      edit: 'Modifier le rôle',
      sections: {
        ...userResourcesLanguageFrench.groups.operations.sections,
        groupsInfo: 'Informations sur le rôle',
      },
    },
    helperTexts: {
      acl_labels: 'Liste des autorisations ACL pour ce rôle',
    },
    names: {
      admin: {
        name: 'Admin',
        description: 'Tous les droits sur toutes les ressources',
      },
      userManager: {
        name: 'Gestionnaire Utilisateurs',
        description: 'Gère les utilisateurs et toutes les ressources associées',
      },
      queueManager: {
        name: 'Gestionnaire Files',
        description: 'Gère les files d’attente et toutes les ressources associées',
      },
      flowManager: {
        name: 'Gestionnaire Flux',
        description: 'Gère les dialplans et toutes les ressources associées',
      },
      supervisor: {
        name: 'Superviseur',
        description: 'Peut voir les CDR et les enregistrements',
      },
      opSupervisor: {
        name: 'Superviseur PO',
        description: 'Visibilité et gestion complète du Panneau Opérateur',
      },
    },
  },
};
